import {
  PatientDocumentDto,
  PatientDocumentCreateDto,
} from "../types/patientDocument";
import apiClient from "./apiClient";

class PatientDocumentCreateService {
  private url = "/PatientDocument";

  private toFormData(data: PatientDocumentCreateDto): FormData {
    const formData = new FormData();

    formData.append("patientId", String(data.patientId));
    formData.append("documentTypeId", String(data.documentTypeId));
    formData.append("format", String(Number(data.format)));

    if (data.fileName) {
      formData.append("fileName", data.fileName);
    }

    if (data.examinationDate) {
      formData.append("examinationDate", data.examinationDate);
    }

    if (data.medicalCenter) {
      formData.append("medicalCenter", data.medicalCenter);
    }

    if (data.documentRemarks) {
      formData.append("documentRemarks", data.documentRemarks);
    }

    if (data.patientSurgeryIds?.length) {
      for (const surgeryId of data.patientSurgeryIds) {
        formData.append("patientSurgeryIds", String(surgeryId));
      }
    }

    if (data.file instanceof File) {
      formData.append("file", data.file, data.file.name);
    }

    return formData;
  }

  async create(
    data: PatientDocumentCreateDto,
    signal?: AbortSignal,
  ): Promise<PatientDocumentDto> {
    const response = await apiClient.post<PatientDocumentDto>(
      this.url,
      this.toFormData(data),
      { signal },
    );

    return response as unknown as PatientDocumentDto;
  }

  async update(
    id: number,
    data: PatientDocumentCreateDto,
    signal?: AbortSignal,
  ): Promise<PatientDocumentDto> {
    const response = await apiClient.put<PatientDocumentDto>(
      `${this.url}/${id}`,
      this.toFormData(data),
      { signal },
    );

    return response as unknown as PatientDocumentDto;
  }
}

export const patientDocumentCreateService = new PatientDocumentCreateService();
